document.querySelector('.year').innerHTML = new Date().getFullYear() + ''
